<div *ngIf="dataIsReady" class="weight-container" (click)="openBottomsheet()">
  <img class="weight-icon" src="assets/plan/weightIcon.png" />
  <div class="weight-title">وزن: {{ weightlog?.weight }} کیلوگرم</div>
  <div class="weight-description">وزن خود را به‌روز رسانی کنید</div>
  <img class="weight-detail-icon" src="assets/general/left-gray.svg" />
</div>
<div *ngIf="!dataIsReady" class="weight-container">
  <ngx-skeleton-loader
    appearance="circle"
    [theme]="{
      top: '24px',
      right: '16px',
      height: '32px',
      width: '32px',
      position: 'absolute',
      'background-color': '#e8eaef',
      margin: '0'
    }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    [theme]="{
      top: '14px',
      right: '64px',
      height: '22px',
      width: '100px',
      position: 'absolute',
      'background-color': '#f8f9fa'
    }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    [theme]="{
      top: '40px',
      right: '64px',
      height: '22px',
      width: '150px',
      position: 'absolute',
      'background-color': '#f3f4f6'
    }"
  ></ngx-skeleton-loader>
  <img class="weight-detail-icon" src="assets/general/left-gray.svg" />
</div>
